var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3319 14H2.66927C1.9326 14 1.33594 13.4033 1.33594 12.6667V3.33333C1.33594 2.59667 1.9326 2 2.66927 2H13.3319C14.0686 2 14.6653 2.59667 14.6653 3.33333V12.6667C14.6653 13.4033 14.0679 14 13.3319 14Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27614 5.05752C6.79684 5.57822 6.79684 6.42244 6.27614 6.94314C5.75545 7.46384 4.91122 7.46384 4.39052 6.94314C3.86983 6.42244 3.86983 5.57822 4.39052 5.05752C4.91122 4.53682 5.75544 4.53682 6.27614 5.05752",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 10.6666L11.8553 8.41661C11.568 8.18661 11.148 8.23327 10.918 8.52061L8.69397 11.3006C8.46397 11.5879 8.04464 11.6346 7.75664 11.4046L6.5113 10.4079C6.22797 10.1813 5.8153 10.2226 5.58264 10.5019L2.66797 13.9999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.8ef00b8f.svg";
export { ForwardRef as ReactComponent };